import React, { useMemo } from "react";
import { UserPlus, ClipboardCheck } from "lucide-react";

import { DashboardCard } from "../DashboardCard";
import { CardHeader } from "../CardHeader";

import { getOnboardingStatusData } from "../../services/dashboardAnalytics";

import { ONBOARDING_ICONS, ONBOARDING_BAR_COLOR,ONBOARDING_DONE_COLOR, } from "../../constants/constants";

export const OnboardingCard = React.memo(function OnboardingCard({
  onboarding,
}) {
  const staged = useMemo(
    () => getOnboardingStatusData(onboarding),
    [onboarding]
  );

  const maxCount = Math.max(...staged.map((item) => item.count), 1);

  const total = onboarding.length;

  return (
    <DashboardCard>
      <CardHeader
        icon={UserPlus}
        iconBg="#EEF2FF"
        iconColor="#4F46E5"
        title="Onboarding"
      />

      <div className="text-xs text-slate-400 font-medium mb-4">
        Employees by Onboarding Status
      </div>

      <div className="space-y-4 flex-1">
        {staged.map((item) => {
          const Icon = ONBOARDING_ICONS[item.label] || ClipboardCheck;

          const completed = item.label === "Completed";

          return (
            <div
              key={item.label}
              className="grid grid-cols-[24px_1fr_80px] gap-3 items-center"
            >
              <span
                className="w-6 h-6 rounded-md flex items-center justify-center"
                style={{
                  background: completed ? "#ECFDF5" : "#FFF7ED",
                }}
              >
                <Icon
                  size={13}
                  style={{
                    color: completed
                      ? ONBOARDING_DONE_COLOR
                      : ONBOARDING_BAR_COLOR,
                  }}
                />
              </span>

              <div>
                <div className="flex justify-between text-xs font-medium text-slate-700 mb-1">
                  <span>{item.label}</span>
                  <span>{item.count}</span>
                </div>

                <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{
                      width: `${(item.count / maxCount) * 100}%`,
                      background: completed
                        ? ONBOARDING_DONE_COLOR
                        : ONBOARDING_BAR_COLOR,
                    }}
                  />
                </div>
              </div>

              <div className="text-right text-xs text-slate-500">
                {total ? ((item.count / total) * 100).toFixed(1) : 0}%
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between">
        <span className="text-sm text-slate-500">
          Total Active Onboarding
        </span>

        <span className="text-xl font-bold text-slate-900">
          {total}
        </span>
      </div>
    </DashboardCard>
  );
});